// extracted by mini-css-extract-plugin
module.exports = {"closeImage":"_1e7x4"};